/* eslint-disable react/jsx-props-no-spreading */
import Layout from 'components/layout/layout';
import SEO from 'components/SEO';
import ProductsListing from './productsListing';

const PageProductsListing = props => {
  const {
    previewData,
    page,
    header,
    footer,
    cart,
    storeLocaleSelector,
    newsletterPopup,
    currency,
    uspBanner,
  } = props;
  const seo = page?.seo;

  return (
    <>
      {seo && <SEO seo={seo} />}
      <Layout
        page={page}
        header={header}
        footer={footer}
        cart={cart}
        previewData={previewData}
        currency={currency}
        newsletterPopup={newsletterPopup}
        uspBanner={uspBanner}
        storeLocaleSelector={storeLocaleSelector}
      >
        <ProductsListing key={page?.shopifyHandle || page.sys?.id} {...props} />
      </Layout>
    </>
  );
};

export default PageProductsListing;
